__turbopack_context__.v({
  "headerText": "PasswordValidation-module-scss-module__IFD9nq__headerText",
  "passwordRow": "PasswordValidation-module-scss-module__IFD9nq__passwordRow",
  "passwordText": "PasswordValidation-module-scss-module__IFD9nq__passwordText",
  "passwordValidationContainer": "PasswordValidation-module-scss-module__IFD9nq__passwordValidationContainer",
});
